import React, { useEffect, useState } from 'react';
import {
  Button, Card, Col, Row,
} from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import {
  addNotificationAction,
  removeNotificationAction,
  selectActionsData,
  updateStepData,
} from '../../../../redux/slices/alertFormSlice/alertFormSlice';
import NotificationAction from './NotificationAction';
import { selectNotificationGroupList } from '../../../../redux/slices/notificationGroupsSlice/notificationGroupsSlice';
import { selectSessionInformation } from '../../../../redux/slices/sessionSlice';
import NewNotificationGroupModal from './NewNotificationGroupModal';
import NewQuietTimeModal from './NewQuietTimeModal';
import NewNotificationTemplateModal from './NewNotificationTemplateModal';
import { createBlankAction } from '../AlertFormUtility';

function DefineActionsForm() {
  const dispatch = useDispatch();
  const { activeSubscription } = useSelector(selectSessionInformation);
  const { actions, errorList } = useSelector(selectActionsData);
  const notificationGroupList = useSelector(selectNotificationGroupList);
  const [showNewQuietTimeModal, setShowNewQuietTimeModal] = useState(false);
  const [showNewNotificationGroupModal, setShowNewNotificationGroupModal] = useState(false);
  const [showNewTemplateModal, setShowNewTemplateModal] = useState(false);
  const [actionIdToApplyNewProperty, setActionIdToApplyNewProperty] = useState(null);

  const hasAdvancedAlerting = activeSubscription.activeTierHasAdvancedAlerting === true;

  useEffect(() => {
    if (!actions || actions.length === 0) {
      dispatch(addNotificationAction({ data: { newAction: createBlankAction() } }));
    }
  }, []);

  const handleUpdate = (updatedAction) => {
    const updatedActions = actions
      .map((action) => (action.id === updatedAction.id ? updatedAction : action));
    dispatch(updateStepData({ step: 'DEFINE_ACTIONS', data: { actions: updatedActions } }));
  };

  const handleDelete = (id) => {
    dispatch(removeNotificationAction({ id }));
  };

  const handleAdd = () => {
    if (!hasAdvancedAlerting && actions.length > 0) {
      return;
    }
    dispatch(addNotificationAction({ data: { newAction: createBlankAction() } }));
  };

  const handleShowNewTemplateModal = (actionId) => {
    setActionIdToApplyNewProperty(actionId);
    setShowNewTemplateModal(true);
  };
  const handleShowNewScheduleModal = (actionId) => {
    setActionIdToApplyNewProperty(actionId);
    setShowNewQuietTimeModal(true);
  };

  const handleShowNewNotificationGroupModal = (actionId) => {
    setActionIdToApplyNewProperty(actionId);
    setShowNewNotificationGroupModal(true);
  };

  const onCreateNewNotificationGroup = (actionId) => {
    setActionIdToApplyNewProperty(actionId);
  };

  return (
    <Card className="alert-card">
      <Card.Body>
        <Row>
          <Col>
            <h6 className="alert-form-section-label">Then, define your actions.</h6>
          </Col>
        </Row>
        <Row className="mb-4 mt-2">
          <Col className="ml-2">
            {actions.map((action, index) => (
              <NotificationAction
                index={index}
                key={action.id}
                action={action}
                notificationGroups={notificationGroupList}
                onUpdate={handleUpdate}
                onDelete={() => handleDelete(action.id)}
                hasAdvancedAlerting={hasAdvancedAlerting}
                showNewGroupModal={handleShowNewNotificationGroupModal}
                showNewScheduleModal={handleShowNewScheduleModal}
                showNewTemplateModal={handleShowNewTemplateModal}
                onCreateNewNotificationGroup={onCreateNewNotificationGroup}
                errorList={errorList}
              />
            ))}
          </Col>
        </Row>
        <Row className="mt-2">
          <Col>
            <div>
              <Button
                variant="secondary"
                onClick={handleAdd}
                disabled={!hasAdvancedAlerting && actions.length > 0}
              >
                Add Action
              </Button>
            </div>
          </Col>
        </Row>
        {!hasAdvancedAlerting && (
          <Row>
            <Col>
              <div className="alert alert-info mt-3">
                <div className="d-flex">
                  <FontAwesomeIcon icon={faInfoCircle} className="mr-1" />
                  <h6>
                    Your current account allows one action for each alert
                  </h6>
                </div>

                <p className="mt-2 ">
                  For advanced functionality including alerts that support
                  multiple actions,
                  repeat notifications, customized notification templates and
                  more, consider
                  <a
                    href="/s/subscription/billing/change-plan"
                    target="_blank"
                  >
                    {' '}
                    upgrading your account
                  </a>
                  .
                </p>
              </div>
            </Col>
          </Row>
        )}
      </Card.Body>
      {showNewNotificationGroupModal && (
      <NewNotificationGroupModal
        show={showNewNotificationGroupModal}
        handleClose={() => setShowNewNotificationGroupModal(false)}
        actionIdToApplyGroup={actionIdToApplyNewProperty}
        onCreateNewNotificationGroup={onCreateNewNotificationGroup}
      />
      )}
      {showNewQuietTimeModal && (
      <NewQuietTimeModal
        show={showNewQuietTimeModal}
        handleClose={() => setShowNewQuietTimeModal(false)}
        actionIdToApplySchedule={actionIdToApplyNewProperty}
      />
      )}

      {showNewTemplateModal && (
      <NewNotificationTemplateModal
        show={showNewTemplateModal}
        handleClose={() => setShowNewTemplateModal(false)}
        actionIdToApplyTemplate={actionIdToApplyNewProperty}
      />
      )}
    </Card>
  );
}

export default DefineActionsForm;
